/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
  GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  GetApiV1ClassroomdisciplineSharedTeachers401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedTeachers.ts";

function getGetApiV1ClassroomdisciplineSharedTeachersUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/teachers` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de professores (Person ativas com IsTeachingStaff = true) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/teachers}
 */
export async function getApiV1ClassroomdisciplineSharedTeachers(
  params?: GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedTeachers401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedTeachersUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
